exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-350ae9ea] .v-container {\n  padding: 0px !important;\n  padding-top: 8px !important;\n}\n[data-v-350ae9ea] .v-alert {\n  padding: 0px !important;\n}\n.centered-block[data-v-350ae9ea] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n", ""]);

// exports
